import React from "react";

import HomeUI from "../../ui/homeUI/_index";

const PlanBossPage = () => {
  return (
    <HomeUI />
  )
}

export default PlanBossPage;
